import styled from 'styled-components';
import BannerPng from '../../../images/banner.png';

const Image = styled.img`
  width: 100%;
`;

const Banner = () => <Image src={BannerPng} alt="Contruction Img" />;

export default Banner;
